import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { BannerInline } from "../../../../../../../components/bannerInline/BannerInline";
import {
  getProfileName,
  hasProfileReachedLimit,
} from "../../../../../../../store/profiles/profiles.selectors";
import { hideProfileLimitWarning } from "../../../../../../../store/banners/banners.actions";
import { isProfileLimitInfoVisible } from "../../../../../../../store/banners/banners.selectors";

interface ProfileDeviceLimitReachedProps {
  profileId: string;
}

export const ProfileDeviceLimitReached = ({
  profileId,
}: ProfileDeviceLimitReachedProps) => {
  const profileName = useSelector(getProfileName(profileId));
  const isLimitReached = useSelector(hasProfileReachedLimit(profileName));
  const isPanelVisible = useSelector(isProfileLimitInfoVisible(profileId));
  const dispatch = useDispatch();

  if (!isPanelVisible || !isLimitReached) return null;

  return (
    <BannerInline
      onClick={() => dispatch(hideProfileLimitWarning(profileId))}
      message={<FormattedMessage id={"profile_device_limit_reached"} />}
    />
  );
};
